import { iconSizes } from '@/theme/tokens';
import { Box, Stack, Text } from '@/ui';
import { CircularProgress } from '@/ui/primitives';
import type { RecoveryUxPhase } from './recoveryUxPhase';
import type { ReactElement } from 'react';

export const RecoveryStatusPanel = ({ phase }: { phase: RecoveryUxPhase }): ReactElement | null => {
  if (phase === 'silent') return null;

  return (
    <Box
      sx={{
        minHeight: '45vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack gap="md" alignItems="center">
        <Text
          role="body"
          color="textSecondary"
          sx={(theme) => ({ fontSize: theme.typography.subtitle1.fontSize })}
        >
          Authenticating user...
        </Text>
        <CircularProgress size={iconSizes.lg} />
      </Stack>
    </Box>
  );
};
